module.exports = __webpack_public_path__ + "img/ring_y_c_1_1@2x.a237ba2c.png";